<div class="panel">
    <div class="panel__header">
        <span class="panel__header__title">
            Templates
        </span>
        <div class="panel__header__button-container">
            <a class="button button--primary" [routerLink]="['/template/setup']"><i class="material-icons button__icon">add</i><span class="button__text">Add New</span></a>
            <a class="button" onclick="$('.panel__sub-header').slideToggle();"><i class="material-icons button__icon">search</i><span class="button__text">Search</span></a>
        </div>
    </div>
    <div class="panel__sub-header" style="display: none;">
        <div class="flex">
            <div class="col">
                <div class="input-container">
                    <span class="label">Customer or Template Name</span>
                    <input onkeypress="return event.keyCode!=13" id="searchCustomerTemplate" type="text" 
                           (change)="searchKeywordChanged($event.target.value)"
                           placeholder="Enter the customer or template name to search for" />
                </div>
            </div>
        </div>
    </div>
    <mat-tab-group class="tab-container">
        <mat-tab label="Ground Engaging Tools">
            <div class="panel__content no-padding">
                <table class="table table--striped">
                    <thead>
                        <tr>
                            <!--<th>Schematics</th>-->
                            <th>Name</th>
                            <th>Customer</th>
                            <th class="align-right">More</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let template of getImplementTemplates">
                            <ng-container *ngIf="template.ShowTemplate">
                                <!--<td>IMG</td>-->
                                <td>{{template.TemplateName}}</td>
                                <td>{{template.CustomerName}}</td>
                                <td class="align-right">
                                    <div *ngIf="template.CustomerName != 'GLOBAL' || userIsGlobalAdmin">
                                        <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                                            <i class="material-icons">more_vert</i>
                                        </button>
                                        <mat-menu #implementMoreMenu="matMenu">
                                            <button mat-menu-item routerLink="/template/setup/{{template.TemplateId}}">
                                                <mat-icon>mode_edit</mat-icon>
                                                <span>Edit Template</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
        <mat-tab label="Dump Bodies">
            <div class="panel__content no-padding">
                <table class="table table--striped">
                    <thead>
                        <tr>
                            <!--<th>Schematics</th>-->
                            <th>Name</th>
                            <th>Customer</th>
                            <th class="align-right">More</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let template of dumpBodyImplementTemplates">
                            <ng-container *ngIf="template.ShowTemplate">
                                <!--<td>IMG</td>-->
                                <td>{{template.TemplateName}}</td>
                                <td>{{template.CustomerName}}</td>
                                <td class="align-right">
                                    <div *ngIf="template.CustomerName != 'GLOBAL' || userIsGlobalAdmin">
                                        <button mat-icon-button [matMenuTriggerFor]="implementMoreMenu">
                                            <i class="material-icons">more_vert</i>
                                        </button>
                                        <mat-menu #implementMoreMenu="matMenu">
                                            <button mat-menu-item routerLink="/template/setup/{{template.TemplateId}}">
                                                <mat-icon>mode_edit</mat-icon>
                                                <span>Edit Template</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>